// extracted by mini-css-extract-plugin
export default {"FormHeader":"FormHeader_FormHeader__HMnnD"};